import { useEffect, useState } from 'react';
import useStableCallback from 'src/hooks/useCallbackUtils/useStableCallback';
import appEvents from 'src/modules/10-app/events';
import { hasValidSession } from 'src/modules/authentication/session/ensureGuestSession';
export default function useSessionBootstrap() {
    const [status, setStatus] = useState('loading');
    const bootstrap = useStableCallback(async () => {
        setStatus('loading');
        try {
            await appEvents.onBoot();
            if (!hasValidSession()) {
                setStatus('error');
                return;
            }
            setStatus('ready');
        }
        catch (error) {
            console.error('Session bootstrap failed:', error);
            setStatus('error');
        }
    });
    useEffect(() => {
        bootstrap();
    }, [bootstrap]);
    return { status, retry: bootstrap };
}
